import React from 'react';
import PropTypes from 'prop-types';
import { Navbar, Nav } from 'react-bootstrap';
import { Link } from 'react-router-dom';
const Moment = require('moment');

const uuid = require('uuid');

const _ = {
    findIndex:  require('lodash/findIndex'),
    find:       require('lodash/find'),
    findLast:   require('lodash/findLast'),
    filter:     require('lodash/filter'),
    forEach:    require('lodash/forEach'),
    map:        require('lodash/map'),
};

const Globals = require('../../../../app/globals');
const Strings = require('../../../../app/shared/Strings');

const ShortCourseInstanceStore = require('../../stores/ShortCourseInstanceStore');
const ShortCourseInstanceActions = require('../../actions/ShortCourseInstanceActions');
const GlobalUserStore = require('../../stores/GlobalUserStore');

const AssetUtil = require('../../util/asset');
const KeyboardUtil = require('../../util/keyboard');
import TileListEmpty from '../tiles/TileListEmpty';
import SortableTableClassic from '../table/SortableTableClassic';
import AccessibleIcon from '../common/AccessibleIcon';
import ActionHistoryPanel from './ActionHistoryPanel';
import ConfirmModal from '../modal/ConfirmModal';
import FeaturedDemoArea from './FeaturedDemoArea'

const propTypes = {
    userInfo: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        display_name: PropTypes.string.isRequired,
    }).isRequired,
    className: PropTypes.string,
    history: PropTypes.object.isRequired,
};
const defaultProps = {
    className: '',
};

const VIEWS = {
    "overview": {
        eventKey: "overview",
        displayName: "Overview",
        // component: <Xxx/>,
    },
    "courses": {
        eventKey: "courses",
        displayName: "Your Courses",
        // component: <Xxx/>,
    },
};

const HISTORY_DATE_FORMAT = 'MM/DD/YYYY HH:mm';

function CourseTiles({localShortCourses,clickHandler,deleteHandler}) {
    if (!localShortCourses) {
        return ( <TileListEmpty promptText="Loading..."/> );
    }
    if (!localShortCourses.length) {
        return (<TileListEmpty promptText={Strings['en'].short_course.skillbuild.NO_ACTIVE_COURSES_INSTRUCTOR} />);
    }
    
    let courseElements = [];
    _.forEach(localShortCourses,(shortCourseInst) => {
        let key = shortCourseInst.hash;
        let courseImg = (<div className="course-img"></div>); // Temp until we get a default course image
        if (shortCourseInst.course_image_url) {
            courseImg = (<img className="course-img" src={AssetUtil.resolveAssetPath(shortCourseInst.course_image_url)} alt=" " aria-hidden />);
        }
            
        courseElements.push(
            <div
                key={key}
                className="course-tile course-tile-interactable"
                tabIndex="0"
                onClick={(e)=>{clickHandler(e, key)}}
                onKeyDown={(e)=>{if (KeyboardUtil.isSelectKey(e.keyCode)) clickHandler(e, key)}}
            >
                {courseImg}
                <div className="course-info">
                    <span className="course-title">{shortCourseInst.name}</span>
                </div>
                <div className="course-delete-button">
                    <button title="delete short course instance" onClick={(e)=>{deleteHandler(e,key)} }>
                        <AccessibleIcon className="fa fa-trash" label="delete short course instance"/>
                    </button>
                </div>
            </div>
        );
    });
    return (
        <div>
            {courseElements}
        </div>
    );
}

const ACTION_HISTORY_COLUMNS = [
    {displayName: 'Date',   key: 'performed_at', size: 1, type: 'date' },
    {displayName: 'Action', key: 'actionName',   size: 5, type: 'string' }, 
];

class AuthorInstHome extends React.Component {
    constructor(props) {
        super(props);
        
        const stateFromStore = this.getStateFromStoreState(props,ShortCourseInstanceStore.getState());
        this.state = {
            selectedTab: 'overview',
            getActionId: null,
            getError: null,
            deleteShortCourseHash: null,
            deleteShortCourseActionId: null,
            deleteShortCourseError: null,
            ...stateFromStore
        };

        this.shortCourseInstClickHandler = this.shortCourseInstClickHandler.bind(this);
        this.unsubscribes = [
            ShortCourseInstanceStore.listen(this.onShortCourseInstanceStoreChange),
        ];
    }

    componentDidMount() {
        if (!this.state.localShortCourses) {
            const getActionId = uuid.v4();
            this.setState({ getActionId: getActionId }, () => {
                ShortCourseInstanceActions.getMinimalCourseInstancesForUser(getActionId);
            })
        }
    }

    componentWillUnmount() {
        this.unsubscribes.forEach(u => u());
    }
    
    getStateFromStoreState=(props,storeState,instanceDetails)=>{
        let localShortCourses;
        if (storeState.intializedLocalMin) {
            localShortCourses = _.filter(
                storeState.minShortCourseInstances,
                { integration_type: Globals.integration_type.LOCAL, role_token: Globals.users.roles.INSTRUCTOR }
            );
        }
        return { localShortCourses };
    }

    onShortCourseInstanceStoreChange=(storeState)=>{
        let additionalState = {};
        if (storeState.action.id === this.state.getActionId) {
            if (!storeState.action.error) {
                additionalState = {
                    ...additionalState,
                    getActionId: null,
                };
            }
            else {
                additionalState = {
                    ...additionalState,
                    getActionId: null,
                    getError: storeState.action.error,
                };
            }
        }
        else if (storeState.action.id === this.state.deleteShortCourseActionId) {
            if (!storeState.action.error) {
                additionalState = {
                    ...additionalState,
                    deleteShortCourseHash: null,
                    deleteShortCourseActionId: null,
                    deleteShortCourseError: null,
                };
            }
            else {
                additionalState = {
                    ...additionalState,
                    deleteShortCourseActionId: null,
                    deleteShortCourseError: storeState.action.error,
                }
            }
        }
        
        const stateFromStore = this.getStateFromStoreState(this.props,storeState, this.state.instanceDetails);
        this.setState({
            ...stateFromStore,
            ...additionalState,
        });
    }

    shortCourseInstClickHandler=(e, hash)=>{
        window.location.href = `/course_instance/${hash}`;
    }
    
    instanceDeleteHandler=(e,hash)=>{
        e.stopPropagation();
        e.preventDefault();
        this.setState({ deleteShortCourseHash: hash });
    }

    handleDeleteShortCourse=()=>{
        const deleteShortCourseActionId = uuid.v4();
        this.setState({ deleteShortCourseActionId: deleteShortCourseActionId }, () => {
            ShortCourseInstanceActions.archiveLocalShortCourseInstance(deleteShortCourseActionId, { instanceHash: this.state.deleteShortCourseHash });
        });
    }

    closeDeleteShortCourseModal=()=>{
        this.setState({
            deleteShortCourseHash: null,
            deleteShortCourseError: null,
        });
    }
    
    onSelectTab=(selectedTab)=>{
        this.setState({selectedTab});
    }
    
    render() {
        let lastLogin = GlobalUserStore.getLastLogin(this.props.userInfo.id);
        
        return (
            <div className={`instructor dashboard ${this.props.className}`} role="main">
                <div className="welcome-message">
                    <span>{Strings['en'].dashboard.WELCOME_MESSAGE}</span>
                    <span className="user-name">{this.props.userInfo.display_name}</span>
                    <span className="avatar"></span>
                    { lastLogin ? 
                    <div className="last-login">
                        <label>{Strings['en'].dashboard.LAST_LOGIN}</label>
                        <span className="login-time">{ Moment(lastLogin.performed_at).format(HISTORY_DATE_FORMAT) }</span>
                    </div>
                    : null }
                </div>
                <Navbar collapseOnSelect expand="lg">
                    <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                    <Navbar.Collapse>
                        <Nav
                            justify
                            variant="tabs"
                            role="tablist"
                            defaultActiveKey="courses"
                            activeKey={this.state.selectedTab}
                            onSelect={this.onSelectTab}
                        >
                            {Object.values(VIEWS).map((view) => (
                                <Nav.Link key={view.eventKey} eventKey={view.eventKey}>
                                    {view.displayName}
                                </Nav.Link>
                            ))}
                        </Nav>
                    </Navbar.Collapse>
                </Navbar>
                
                {(this.state.selectedTab === 'courses') ? 
                <div className="content">
                    <div className="left-content instructor-course-list">
                        <h2 className="section-title">{Strings['en'].dashboard.YOUR_COURSES}</h2>
                        <CourseTiles 
                            localShortCourses={this.state.localShortCourses} 
                            clickHandler={this.shortCourseInstClickHandler}
                            deleteHandler={this.instanceDeleteHandler}
                            />
                    </div>
                </div>
                :
                <div className="content">
                    <div className="left-content">
                        <FeaturedDemoArea className="margin-bottom-lg" />
                        <ActionHistoryPanel userInfo={this.props.userInfo} history={this.props.history}/>
                    </div>
                    {/*<div className="right-content">
                    </div>*/}
                </div>
                }
                {!!this.state.deleteShortCourseHash &&
                    <ConfirmModal
                        show
                        modalTitle="Delete short course instance"
                        text="Are you sure you want to delete this short course instance?"
                        buttonText="delete"
                        confirmButtonBsStyle="danger"
                        hasError={!!this.state.deleteShortCourseError}
                        message={!!this.state.deleteShortCourseError ? this.state.deleteShortCourseError.message : null}
                        closeHandler={this.closeDeleteShortCourseModal}
                        confirmHandler={this.handleDeleteShortCourse}
                    />
                }
            </div>
        );
    }
} // AuthorInstHome

AuthorInstHome.propTypes = propTypes;
AuthorInstHome.defaultProps = defaultProps;

export default AuthorInstHome;
